import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "table1"
};
import { Type } from '../config';
import { indexMethod } from '@/utils/indexMethod';
export default {
  __name: 'table',
  props: {
    data: {
      type: Array
    },
    page: {
      type: Number
    },
    size: {
      type: Number
    },
    total: {
      type: Number
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delUserHandler', 'handleCurrentChange', 'updateUserHandler'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const delUserHandler = row => {
      emit('delUserHandler', row);
    };
    const updateUserHandler = row => {
      emit('updateUserHandler', row);
    };
    const handleCurrentChange = val => {
      emit('handleCurrentChange', val);
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: __props.data,
        border: "",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "#",
          type: "index",
          index: index => _unref(indexMethod)(index, __props.page, __props.size)
        }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
          prop: "auditorName",
          label: "审批人姓名"
        }), _createVNode(_component_el_table_column, {
          prop: "level",
          label: "审批顺序节点"
        }), _createVNode(_component_el_table_column, {
          label: "审批的事项类型"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_tag, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(Type)[row === null || row === void 0 ? void 0 : row.type]), 1)]),
            _: 2
          }, 1024)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "260"
        }, {
          default: _withCtx(({
            row
          }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => updateUserHandler(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 修改 ")]),
            _: 2
          }, 1032, ["onClick"])), [[_directive_permission, ['userDelete']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "danger",
            size: "small",
            onClick: $event => delUserHandler(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除 ")]),
            _: 2
          }, 1032, ["onClick"])), [[_directive_permission, ['userDelete']]])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, __props.loading]]), _createVNode(_component_el_pagination, {
        class: "pagination",
        onCurrentChange: handleCurrentChange,
        "current-page": __props.page,
        "page-size": __props.size,
        layout: "total,  prev, pager, next, jumper",
        total: __props.total
      }, null, 8, ["current-page", "page-size", "total"])]);
    };
  }
};